import React from 'react'
import { Flex } from '@leverege/ui-elements'
import GridLoader from 'react-spinners/GridLoader'

export default function() {
  return <Flex align="center" justify="center" style={{ width : '100%', height : '100%' }}><div><GridLoader /></div></Flex>
}
